import { render } from "./PlanCategoryEdit.vue?vue&type=template&id=5e4fc4d1"
import script from "./PlanCategoryEdit.vue?vue&type=script&lang=js"
export * from "./PlanCategoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\everlife-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__